<template>
  <div class="outter-modal">
    <div class="modal fade show" style="display: block; overflow: scroll" tabindex="-1" @click="onClose">
      <div class="modal-dialog modal-md modal-dialog-centered" @click.stop="">
        <div class="modal-content">
          <div class="modal-header">
            <span>Reverse Incident #{{ incident.id }}</span>
            <button @click="onClose" type="button" class="close" aria-label="Close">×</button>
          </div>
          <div class="modal-body">
            <p>
              You are about to reverse a <strong>{{ incident.incidentType }}</strong> incident
              with score impact <strong>{{ incident.scoreImpact }}</strong>.
              The carrier's trust score will be recalculated.
            </p>

            <div class="form-group">
              <label>Reversal reason <span class="text-danger">*</span></label>
              <textarea
                v-model="reason"
                class="form-control"
                rows="3"
                maxlength="500"
                placeholder="Why is this incident being reversed?"
              />
            </div>

            <div v-if="error" class="alert alert-danger py-2">{{ error }}</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="onClose">Cancel</button>
            <button
              type="button"
              class="btn btn-danger"
              :disabled="saving || !reason.trim()"
              @click="confirm"
            >{{ saving ? 'Reversing…' : 'Reverse Incident' }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop" />
  </div>
</template>

<script>
import { ApiClient } from '@/api/ApiClient';

export default {
  name: 'CarrierIncidentReverseModal',
  props: {
    incident: { type: Object, required: true },
    onClose: { type: Function, default: () => {} },
  },
  data() {
    return {
      reason: '',
      saving: false,
      error: '',
    };
  },
  methods: {
    async confirm() {
      if (!this.reason.trim()) return;
      this.saving = true;
      this.error = '';
      const response = await ApiClient.carrierIncidents.reverse({
        id: this.incident.id,
        body: { reversalReason: this.reason.trim() },
      });
      this.saving = false;
      if (response.status === 200) {
        this.$emit('reversed', response.data.data);
      } else if (response.status === 403) {
        this.error = 'Only admin/manager can reverse incidents.';
      } else if (response.status === 400) {
        this.error = response.data.message || 'Reverse failed';
      } else if (response.status === 422) {
        const first = response.data.errors ? Object.values(response.data.errors)[0] : null;
        this.error = (first && first[0]) || 'Validation failed';
      } else {
        this.error = 'Unexpected error';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.outter-modal {
  position: absolute;
  z-index: 1089;
}
</style>
